import { Box, Link, SxProps, Theme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { UseTableCellProps } from 'react-table';
import { ContractReviewGridItem } from 'shared/types';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

const linkStyles: SxProps<Theme> = {
  cursor: 'pointer',
};

export function ContractLinkColumn(props: UseTableCellProps<ContractReviewGridItem>) {
  const history = useHistory();
  const {
    value,
    row: {
      original: { customerName, brand, id },
    },
  } = props;

  return (
    <Box sx={gridStyles}>
      <Link
        sx={linkStyles}
        onClick={() => {
          history.push(`/customer-management/customer-details/${customerName}/${brand}/viewContract/${id}`);
        }}
      >
        {value}
      </Link>
    </Box>
  );
}
